<template>
    <div id="app">
        <Navbar />
        <keep-alive :include="keepLive">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
import Navbar from './components/Navbar.vue';

export default {
    name: 'App',
    components: {
        Navbar,
    },
    created() {
        this.$i18n.locale = localStorage.getItem('lang') || 'zh';
    }
}
</script>

<style>
#app {
    margin: 0 auto;
    width: 1200px;
}
</style>
